/* eslint-disable no-unused-vars */
import { Alert, Box, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeaderPageDefault from "pages/admin/components/HeaderPageDefault";
import ItemCardDefault from "pages/admin/components/ItemCardDefault";
import EditModal from "./components/EditModal";
import NewModal from "./components/NewModal";
import SearchAppBar from "components/CODXSearchAppBar/SearchAppBar";
import CustomPaginationActionsTable from "components/CODXTablePagination/TablePaginationActions";
import SimpleBackdrop from "components/SimpleBackdrop";
import EmptyCard from "pages/admin/components/EmptyCard";

import {
  getAllWorkout,
  newWorkout,
  deleteWorkout,
  patchWorkout,
} from "api/crud/hooks/useTreinos";
import HeaderTreinos from "./components/HeaderTreinos";
import TableTreinos from "./components/TableTreinos";
import { getAllWorkoutWithoutMedia } from "api/crud/hooks/useTreinos";
import { getAllExerciseAutocomplete } from "api/crud/hooks/useExercicios";

const PAGE_NAME = "Treinos";

const Treinos = () => {
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openText, setOpenText] = useState("");
  const [openErr, setOpenErr] = useState(false);
  const [openErrText, setOpenErrText] = useState("");
  const [busca, setBusca] = useState("");
  const [items, setItems] = useState([]);
  const [exercicios, setExercicios] = useState([]);
  const [open, setOpen] = useState(true);

  const handleClose = () => setOpenSuccess(false);
  const handleCloseErr = () => setOpenErr(false);

  const [loadingExercicios, setLoadingExercicios] = useState(true);


  useEffect(() => {
    GetItens();
    GetExercicios();
  }, []);

  const GetExercicios = async () => {
    try {
      const { status, message } = await getAllExerciseAutocomplete();
      if (status === 200) {
        setExercicios(message);
        setLoadingExercicios(false)
      } else {
        setExercicios([]);
        setLoadingExercicios(false)
      }
    } catch (error) {
      setExercicios([]);
      setLoadingExercicios(false)
    }
  };

  const GetItens = async () => {
    try {
      const { status, message } = await getAllWorkoutWithoutMedia();

      setOpen(false)
      if (status === 200) {
        console.log('GetItens Treinos: ', message)
        setItems(message);
      } else {
        setItems([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const AddNewItem = async (payload) => {
    setOpen(true)
    try {
      const { status, message } = await newWorkout(payload);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const handleDeleteItem = async (id) => {
    setOpen(true)
    try {
      const { status, message } = await deleteWorkout(id);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const handlePatchItem = async (id, payload) => {
    setOpen(true)
    try {
      const { status, message } = await patchWorkout(id, payload);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const setRes = (status, message) => {
    if (status === 200) {
      setOpenText(message);
      setOpenSuccess(true);
    } else {
      setOpenErrText(message);
      setOpenErr(true);
    }
  }

  return (
    <>
      <SimpleBackdrop open={open} />
      <HeaderTreinos addFunction={AddNewItem} tittle={PAGE_NAME} NewModal={NewModal} exercicios={exercicios} loadingExercicios={loadingExercicios}/>
      <Box component="main" sx={{ flex: 1, py: 6, px: 4, bgcolor: "#f2f2f2" }}>
        <SearchAppBar
          value={busca}
          onChange={(caracter) => {
            setBusca(caracter);
          }}
        />
        <br />
        {items ? (
          <TableTreinos
            itens={items}
            busca={busca}
            EditModal={EditModal}
            handleDeleteItem={handleDeleteItem}
            handlePatchItem={handlePatchItem}
            exercicios={exercicios}
            loadingExercicios={loadingExercicios}
          />
        ) : (

          <EmptyCard nome="Treinos não encontrados" />
        )}
      </Box>
      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {openText}
        </Alert>
      </Snackbar>
      <Snackbar open={openErr} autoHideDuration={3000} onClose={handleCloseErr}>
        <Alert onClose={handleCloseErr} severity="error" sx={{ width: "100%" }}>
          {openErrText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Treinos;
